import React, { createContext, useState, useEffect } from "react";
import csrfService from "./utils/csrfService";
import { apiService } from "./backend/api";
import { setReportContext } from "./utils/errorReporter";

export const LoginContext = createContext();

export const LoginProvider = ({ children }) => {
  const [loginInfo, setLoginInfo] = useState(null);
  const [loading, setLoading] = useState(true);

  // Fehlerberichte aus dem Browser sollen den Nutzer benennen können. Der
  // Name liegt nur hier im State, nicht im localStorage.
  useEffect(() => {
    setReportContext({ username: loginInfo?.username });
  }, [loginInfo?.username]);

  // Restore login state on mount
  useEffect(() => {
    const restoreSession = async () => {
      try {
        // Cleanup legacy localStorage keys, but keep `authToken` (used as Bearer fallback for Safari)
        localStorage.removeItem("token");
        localStorage.removeItem("username");
        localStorage.removeItem("user");

        // Verify session with backend (Authorization-Header oder HTTP-only Cookie)
        const data = await apiService.checkAuth();
        if (data?.authenticated && data?.user) {
          setLoginInfo({
            isLoggedIn: true,
            username: data.user.username,
            user: data.user
          });
        }
      } catch (err) {
        // console.log("No active session found or verified");
      } finally {
        setLoading(false);
      }
    };

    restoreSession();
  }, []);

  const login = (token, username, user) => {
    // In production, token is managed via HTTP-only cookie.
    // We update local state only.
    setLoginInfo({ isLoggedIn: true, username, user });
  };

  const logout = () => {
    setLoginInfo(null);
    localStorage.removeItem("token");
    localStorage.removeItem("authToken");
    localStorage.removeItem("username");
    localStorage.removeItem("user");
    localStorage.removeItem("last2FAVerified");
    // 🔒 Clear CSRF token on logout
    csrfService.clearToken();
  };

  return (
    <LoginContext.Provider value={{ loginInfo, login, logout, loading }}>
      {children}
    </LoginContext.Provider>
  );
};
